import Alpine from "alpinejs";
import { $http } from "../../utils";

Alpine.data('customForm', () => ({
    errors: null,

    removeError(field) {
        if (!this.errors) {
            return false;
        }
        delete this.errors[field];
    },

    clearForm(el) {
      const list = el.querySelectorAll('[name]');
      console.log(list);
      list.forEach(item => {
          this.removeError(item.name);
      })
      el.reset();
    },

    getError(field) {
        if (!this.errors) {
            return '';
        }
        if (Array.isArray(this.errors[field])) {
            return this.errors[field][0];
        }
        return this.errors[field] || '';
    },

    checkError(field) {
        if (!this.errors) {
            return false;
        }
        return this.errors[field] ? true : false;
    },

    submitForm(form) {
        const formData = new FormData();
        Array.from(form.elements).forEach(element => {
            if (element.name) {
                formData.append(element.name, element.value);
            }
        });

        $http.post(form.action, formData, {
            headers: {
                'Accept': 'application/json'
            }
        })
        .then(response => {
            this.$dispatch('response', {response: response});
        })
        .catch(error => {
            this.errors = error.response.data.errors
        });
    },

    submitFormPatch(form) {
        const formData = {};
        Array.from(form.elements).forEach(element => {
            if (element.name) {
                formData[element.name] = element.value;
            }
        });

        $http.patch(form.action, formData, {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        })
            .then(response => {
                this.$dispatch('response', {response: response});
            })
            .catch(error => {
                if (error.response && error.response.status === 422) {
                    this.errors = error.response.data.errors
                }
                if (error.response && error.response.status === 401) {
                    this.errors = error.response.data.errors
                }
            });
    }
}))